// extracted by mini-css-extract-plugin
export default {"mainSection":"application-testing-step-1_mainSection__gzR2C"};